<template>
  <div>
    <div v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;">
      <div>
        <div>
          <h3>Getting Tickets ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Tickets</h1>
        </div>
        <div class="col-auto">
          <button v-if="permissions.includes('create-ticket')" class="button button--outline text-uppercase" @click="showTicketModal">
            Create Ticket
          </button>
        </div>
      </div>
      <modal v-show="createTicketModal" @close="createTicketModal = false" footer modalIsLarge>
        <template v-slot:title>
          <h5>Create Ticket</h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="title">Title</label>
            <input type="text" class="form-control" name="title"
              v-model="ticket.title" />
          </div>
          <div class="form-group">
            <label for="">Categories</label>
            <select name="" id="" class="form-control" v-model="ticket.type">
              <option value="" selected>Category</option>
              <option :value="categories.id" v-for="(categories, index) of categories" :key="index">
                {{ `${categories.name} ` }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Assign To</label>
            <select name="" id="" class="form-control" v-model="ticket.assigned_to">
              <option value="" selected>Assign to</option>
              <option :value="item.id" v-for="(item, index) of staffs" :key="index">
                {{ `${item.first_name} ${item.last_name}` }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Image</label>
            <input
              type="file"
              class="upload"
              ref="fileChange"
              accept="*"
              @change="onFilePickedButton"
            />
          </div>
          <div class="form-group">
            <label for="body">Body</label>
            <textarea name="body" id=""  cols="30" rows="10" placeholder="Description..." class="form-control"
              v-model="ticket.body" style="resize: none"></textarea>
          </div>
        </template>
        <template v-slot:footer>
          <button class="btn btn-success text-white" @click.prevent="createTicket"
            :disabled="sendLoading">
            <span class="custom-loader" v-if="sendLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">Creating Ticket...</span>
            </span>
            <span v-else>
              Create Ticket
            </span>
          </button>
          <button @click.prevent="sendPushModal" class="btn btn-secondary">
            Cancel
          </button>
        </template>
      </modal>

      <div class="row" v-if="stats">
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="dangerColor"
            :textColor="textColor"
            :text="'All Stats'"
            :value="stats.all_tickets"
            :valueColor="valueColor"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="'blue'"
            :textColor="'white'"
            :text="'Open Tickets'"
            :value="stats.open_tickets"
            :valueColor="'white'"
            :cardImg="usersIcon"
          />
        </div>
        <div class="col-xl-2 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="activeColor"
            :textColor="textColor"
            :text="'Closed Tickets'"
            :value="stats.closed_ticket"
            :valueColor="valueColor"
            :cardImg="usersIcon"
          />
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <CDataTable :items="pageData" :fields="fields" sorter>
            <template #created_by="{ item }">
              <td>
                {{ `${item.created_by_user.first_name} ${item.created_by_user.last_name}` }}
              </td>
            </template>
            <template #assigned_to="{ item }">
              <td>
                <div v-if="item.assigned_to_user">{{ `${item.assigned_to_user.first_name} ${item.assigned_to_user.last_name}` }}</div>
                <div v-else>Not Assigned</div>
              </td>
            </template>
            <template #date="{ item }">
              <td>
                {{item.created_at | date}}
              </td>
            </template>
            <template #status="{ item }">
              <td>
                <span v-if="item.status === 'open'" class="badge badge-success">Open</span>
                <span v-else class="badge badge-danger">Closed</span>
              </td>
            </template>
            <template #action="{ item }">
              <td class="table--action-mobile">
                <router-link class="button" v-if="permissions.includes('view-ticket')" :to="{
                  name: 'Ticket',
                  params: { slug: item.reference }
                }">
                  View
                </router-link>
              </td>
            </template>
          </CDataTable>
          <CPagination :activePage.sync="next_page" :pages="total" :onActivePageChange="onPageChange()"></CPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "../../services/api.service";
import CPagination from "../../components/CPagination.vue";
import CCard from "../../components/CCard.vue";
import usersIcon from "@/assets/images/users-avatar.png";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";

const fields = [
  "reference",
  "created_by",
  "assigned_to",
  "title",
  "type",
  "status",
  "date",
  "action"
];
export default {
  name: "ReferralsPage",
  data() {
    return {
      usersIcon,
      activeColor: "#2CB858",
      dangerColor: "#FBC108",
      textColor: "#001833",
      valueColor: "#001833",
      sendLoading: false,
      fields,
      pageData: null,
      pageLoading: true,
      arr: [],
      user_id: "",
      next_page: 1,
      total: 1,
      current: 1,
      getStaffLoading: false,
      stats: null,
      staffs: [],
      categories: [],
      ticket: {
        title : "",
        body : "",
        support_category_id : null,
        assigned_to : null,
        image : null
      },
      createTicketModal: false,
    };
  },
  components: {
    CDataTable,
    CCard,
    CPagination
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    onFilePickedButton(event) {
      const files = event.target.files;
      let filename = files[0].name;
      this.filename = filename;
      this.imageFileType = files[0].type.match(/.(jpg|jpeg|png)$/i);
      if (filename.lastIndexOf(".") <= 0) {
        return alert("please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        // this.service.image = fileReader.result;
        // this.base_six = fileReader.result;
        // console.log(this.service.image);
        // console.log(this.service);
      });
      fileReader.readAsDataURL(files[0]);
      this.ticket.image = files[0];
    },
    showTicketModal(item = null) {
      this.createTicketModal = true;
    },
    closeTicketModal() {
      this.isPushNotificationModal = false;
      // this.pushNotification = {};
      this.ticket.title = "";
      this.ticket.body = "";
      this.ticket.support_category_id = null;    
      this.ticket.assigned_to = null;  
      this.ticket.image = null;
    },
    func() {
      console.log("Here");
    },
    async getTickets(page) {
      try {
        const res = await ApiService.get(
          `ticket/all?page=${page}`
        );        
        this.pageData = res.data.data.data;
        this.total = res.data.data.last_page;
        this.current = res.data.data.current_page;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error.response);
      }
    },
    async getStats() {
      try {
        const response = await ApiService.get("ticket/stats");
        this.stats = response.data.data;
      } catch (error) {
        console.log(error);
        console.log(error.response);
      }
    },
    async getStaffs() {
      try {
        this.getStaffLoading = true;
        const response = await ApiService.get("user/staffs");
        this.staffs = response.data.data;
        this.getStaffLoading = false;
      } catch (error) {
        console.log(error);
        this.getStaffLoading = false;
        console.log(error.response);
      }
    },
    async getCategories() {
      try {
        const response = await ApiService.get("ticket/categories");
        this.categories = response.data.data;
      } catch (error) {
        console.log(error);
        console.log(error.response);
      }
    },
    async createTicket() {
      try {
        this.sendLoading = true;
        let formData = new FormData();
        formData.append("title", this.ticket.title);
        formData.append("body", this.ticket.body);
        formData.append("support_category_id", this.ticket.type);
        if (this.ticket.assigned_to){
          formData.append("assigned_to", this.ticket.assigned_to);
        }       
        formData.append("image", this.ticket.image);
        const headers = { "Content-Type": "multipart/form-data" };
        const response = await ApiService.post("ticket/create", formData,  { headers });
        this.sendLoading = false;
        this.createTicketModal = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        // this.getTickets(1);
        //redirect to the ticket page
        this.$router.push({ name: "Ticket", params: { slug: response.data.data.reference } });
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        this.sendLoading = false;
        console.log(_error);
        this.createTicketModal = false;
        ErrorService.displayErrorAlert(_error);
      }
    },
    onPageChange() {
      console.log(this.next_page);
      if (this.current != this.next_page) {
        this.getTickets(this.next_page);
      }
    }
  },
  mounted() {
    this.getTickets(1);
    if (this.can("staffs")) {
      this.getStaffs();
    }
    this.getCategories();
    this.getStats();
  }
};
</script>

<style scoped></style>
